import apiClient from './api';

// Servicio para ingresos/gastos recurrentes y sus excepciones (omitir o
// editar una sola ocurrencia). Espeja el endpoint /recurring del backend
// (app/api/v1/endpoints/recurring.py).
const recurringService = {
  getIncomes: async () => apiClient.get('/recurring/incomes'),
  createIncome: async (data) => apiClient.post('/recurring/incomes', data),
  updateIncome: async (id, data) => apiClient.put(`/recurring/incomes/${id}`, data),
  deleteIncome: async (id) => apiClient.delete(`/recurring/incomes/${id}`),

  getExpenses: async () => apiClient.get('/recurring/expenses'),
  createExpense: async (data) => apiClient.post('/recurring/expenses', data),
  updateExpense: async (id, data) => apiClient.put(`/recurring/expenses/${id}`, data),
  deleteExpense: async (id) => apiClient.delete(`/recurring/expenses/${id}`),

  getExceptions: async (itemTipo, itemId) => apiClient.get(`/recurring/${itemTipo}/${itemId}/exceptions`),
  createException: async (itemTipo, itemId, data) =>
    apiClient.post(`/recurring/${itemTipo}/${itemId}/exceptions`, data),
  deleteException: async (exceptionId) => apiClient.delete(`/recurring/exceptions/${exceptionId}`),
};

export default recurringService;
